// frontend/packs/application.js

/* eslint-disable import/first, import/newline-after-import */

import 'init/polyfills';

import 'styleguide';
import 'init';

import 'layouts/page/page';
import 'components/global/site-header/site-header';
import 'components/global/site-footer/site-footer';

import(/* webpackPreload: true */ 'components/sessions/login-form/login-form');
import(/* webpackPreload: true */ 'components/sessions/registration-form/registration-form');
import(/* webpackPrefetch: true */ 'components/sessions/reset-password-form/reset-password-form');
import(/* webpackPrefetch: true */ 'components/sessions/update-password-form/update-password-form');

import(/* webpackPrefetch: true */ 'components/sessions/signup-survey/signup-survey');
import(/* webpackPrefetch: true */ 'components/sessions/email-verification/email-verification');

import 'components/util/ad-container/ad-container';
import 'components/util/logos/logos';

import 'components/util/resource-action-buttons/resource-action-buttons';

import 'components/resources/show/modal-view/modal-view'; // split-test: resource_show_modal_view

/* shared */
import 'components/global/ads/ads';
import 'components/resources/grid/grid';
import 'components/resources/vertical-grid/vertical-grid'; // split-test vgrid_inf_scroll_v3
import 'components/util/pricing-block/pricing-block';
import 'components/pricing/faq/faq';
import 'components/util/tags-carousel/tags-carousel';
import 'components/global/promos/promo-popup';
import 'components/util/block-pager/block-pager';
import 'components/util/ez-drop-down/ez-drop-down';
import 'components/util/ez-double-range/ez-double-range';
import 'components/global/site-banners/site-banner';
import 'components/following/follow-button/follow-button';
import 'components/global/promos/redirector-app-notice/redirector-app-popover';

import(/* webpackPreload: true */ 'components/collections/collection-util-modal');
import(/* webpackPreload: true */ 'components/collections/collections-modal/collections-modal');
import(/* webpackPreload: true */ 'components/collections/collections-search-form/collections-search-form');
import(/* webpackPreload: true */ 'components/collections/collections-privacy-control/collections-privacy-control');
import(/* webpackPrefetch: true */ 'components/collections/collections-alert/collections-alert');

import(/* webpackPreload: true */ 'components/util/social-sharing/share-modal/share-modal');

import 'components/util/copy-link/copy-link';
import 'components/contributors/contributor-details/contributor-details';
import 'components/util/faq/faq';
import 'components/static/rebrand/rebrand';

import 'components/global/support/rate-limit/rate-limit';

import { featureEnabled, splitTestEnabled } from 'lib/helpers'; // eslint-disable-line import/order

import { Application } from 'stimulus';
export const application = Application.start(); // eslint-disable-line import/prefer-default-export

import AdsController from 'controllers/ads-controller';
application.register('ads-main', AdsController);

import GoogleAnalyticsController from 'components/analytics/google/google-analytics-controller';
application.register('google-analytics', GoogleAnalyticsController);

import GoogleTagManagerController from 'components/analytics/google-tag-manager/google-tag-manager-controller';
application.register('google-tag-manager', GoogleTagManagerController);

import KlaviyoAnalyticsController from 'components/analytics/klaviyo/klaviyo-analytics-controller';
application.register('klaviyo-analytics', KlaviyoAnalyticsController);

import FacebookAnalyticsController from 'components/analytics/facebook/facebook-analytics-controller';
application.register('facebook-analytics', FacebookAnalyticsController);

import PinterestAnalyticsController from 'components/analytics/pinterest/pinterest-analytics-controller';
application.register('pinterest-analytics', PinterestAnalyticsController);

import ClickTrackController from 'controllers/click-track-controller';
application.register('click-track', ClickTrackController);

import RelatedResourceController from 'controllers/related-resource-controller';
application.register('related-resource', RelatedResourceController);

import SiteHeaderController from 'components/global/site-header/site-header-controller';
application.register('site-header', SiteHeaderController);

import SiteBannerController from 'components/global/site-banners/site-banner-controller';
application.register('site-banner', SiteBannerController);

import LanguageSwitcherController from 'components/util/language-switcher/language-switcher-controller';
application.register('language-switcher', LanguageSwitcherController);

import FlashMessageController from 'components/util/alerts/flash/flash-message-controller';
application.register('flash-message', FlashMessageController);

import ApplicationController from 'components/global/application/application-controller';
application.register('application', ApplicationController);

import FooterAdController from 'controllers/footer-ad-controller';
application.register('footer-ad', FooterAdController);

import('layouts/modal/modal-controller')
  .then((controller) => {
    application.register('ez-modal', controller.default);
  });

import('components/sessions/login-form/login-form-controller')
  .then((controller) => {
    application.register('login-form', controller.default);
  });

import SearchAnalyticsController from 'components/analytics/search/search-analytics-controller';
application.register('search-analytics', SearchAnalyticsController);

import SearchController from 'controllers/search-controller';
application.register('ez-search', SearchController);

import SearchFormController from 'components/search/search-form/search-form-controller';
application.register('search-form', SearchFormController);

import('components/partner/partner-popup-controller')
  .then((controller) => {
    application.register('partner-popup', controller.default);
  });

import('components/sessions/registration-form/account-form-controller')
  .then((controller) => {
    application.register('registrations-account-form', controller.default);
  });

import('components/sessions/registration-form/details-form-controller')
  .then((controller) => {
    application.register('registrations-details-form', controller.default);
  });

import('components/sessions/reset-password-form/reset-password-form-controller')
  .then((controller) => {
    application.register('reset-password-form', controller.default);
  });

import RecaptchaController from 'components/util/recaptcha/recaptcha-controller';
application.register('recaptcha', RecaptchaController);

import SocialSessionButtonsController from 'components/sessions/social-session-buttons/social-session-buttons-controller';
application.register('social-session-buttons', SocialSessionButtonsController);

import ResourcesGridController from 'components/resources/grid/grid-controller';
application.register('resources-grid', ResourcesGridController);

import('components/sessions/signup-modal-controller')
  .then((controller) => {
    application.register('signup-modal', controller.default);
  });

import('components/sessions/signup-survey/signup-survey-modal-controller')
  .then((controller) => {
    application.register('signup-survey-modal', controller.default);
  });

import('components/sessions/signup-survey/signup-survey-form-controller')
  .then((controller) => {
    application.register('signup-survey-form', controller.default);
  });

import('components/sessions/email-verification/email-verification-modal-controller')
  .then((controller) => {
    application.register('email-verification-modal', controller.default);
  });

import('components/sessions/email-verification/email-verified-modal-controller')
  .then((controller) => {
    application.register('email-verified-modal', controller.default);
  });

import('components/sessions/google-one-tap/google-one-tap-controller')
  .then((controller) => {
    application.register('google-one-tap', controller.default);
  });

import('components/util/ez-drop-down/ez-drop-down-controller')
  .then((controller) => {
    application.register('ez-drop-down', controller.default);
  });

import('components/collections/collections-modal/collections-modal-controller')
  .then((controller) => {
    application.register('collections-modal', controller.default);
  });

import('components/collections/collections-modal/collections-modal-form-controller')
  .then((controller) => {
    application.register('collections-modal-form', controller.default);
  });

import('components/collections/collections-search-form/collections-search-form-controller')
  .then((controller) => {
    application.register('collections-search-form', controller.default);
  });

import('components/collections/collections-privacy-control/collections-privacy-control-controller')
  .then((controller) => {
    application.register('collections-privacy-control', controller.default);
  });

import('components/collections/collections-alert/collections-alert-controller')
  .then((controller) => {
    application.register('collections-alert', controller.default);
  });

import BrowseController from 'components/resources/browse/browse-controller';
application.register('browse', BrowseController);

/* start: split-test vgrid_inf_scroll_v3 */

import ResourcesVerticalGridController from 'components/resources/vertical-grid/vertical-grid-controller';
import InfiniteScrollController from 'components/search/search-results/infinite-scroll-controller';

if (splitTestEnabled('vertical-grid-infinite-scroll')) {
  application.register('vertical-grid', ResourcesVerticalGridController);
  application.register('infinite-scroll', InfiniteScrollController);
}

/* end: split-test vgrid_inf_scroll_v3 */

/* start: split-test search_and_explore */
import SearchExploreNavController from 'components/global/search-explore-nav/search-explore-nav-controller';
if (splitTestEnabled('search-and-explore')) {
  application.register('search-explore-nav', SearchExploreNavController);
}
/* end: split-test search_and_explore */

import ThumbnailContribInfoController from 'components/resources/grid/contrib-info-controller';
application.register('thumbnail-contributor-info', ThumbnailContribInfoController);

import FollowButtonController from 'components/following/follow-button/follow-button-controller';
if (featureEnabled('following')) {
  application.register('follow-button', FollowButtonController);
}

import CollectionSaveButtonController from 'components/collections/collection-save-button/collection-save-button-controller';
application.register('collection-save-button', CollectionSaveButtonController);

import VideoPreviewController from 'components/video/preview/video-preview-controller';
application.register('video-preview', VideoPreviewController);

import ExploreNavController from 'components/sessions/explore-nav-controller';
application.register('explore-nav', ExploreNavController);

import AffiliateController from 'components/static/affiliate/affiliate-controller';
application.register('affiliate', AffiliateController);

import SmoothScrollController from 'controllers/smooth-scroll-controller';
application.register('smooth-scroll', SmoothScrollController);

import PromoPopupController from 'components/global/promos/promo-popup-controller';
application.register('promo-popup', PromoPopupController);
